import contact from './contact';
import conf from '../configs/index';
import axios from 'axios'

import {
  BusinessError,
  RequestError,
  UnexpectedError,
  toData,
  errorHandle,
  handle,
} from "@/utils/";

const env = conf.debug ? 'develop' : 'production';

export class Api {
    get instance(){
        return contact.remote(env);
    }
    setOption({ token_type, access_token }){
        contact.remote(env).origin.defaults.headers.common['Authorization'] = `${token_type} ${access_token}`;
    }
    login(account){
        return contact.remote('account').sync({
            method: 'POST',
            url:`/user/login`,
            data: account,
            withCredentials: true
        }).then(handle, errorHandle);
    }
    logout() {
        const csrfCookieMatch = document.cookie.match(/.*csrftoken=([^;.]*).*$/)
        return contact.remote('account').sync({
            method: 'POST',
            url: `/user/logout`,
            headers: { 'X-CSRFToken':csrfCookieMatch[1] }
        }).then(handle, errorHandle)
    }
    updateCoursesItemVideoStatus(course_item_id){
        return this.instance.get(`/course_items/${course_item_id}/checkTranscoding`).then(handle, errorHandle);
    }
    authorize(data){
        return this.instance.post( process.env.NODE_ENV == 'production' ? location.origin + '/oauth/token' : location.origin + '/oauth/token', data).then(toData, errorHandle);
    }
    meida(id){
        return this.instance.get(`/media/${id}`).then(handle, errorHandle);
    }
    typeface({ words, typeface = 1, toLang}){
        return this.instance.get(`/common/typeface`, { words, typeface, toLang })
    }
    currencyExchange(value, year, unit="元", currency="", ){
      return this.instance.get(`/common/currencyExchange`, { year, value, currency, unit })
    }
    //汇率货币列表
    currencyList(){
        return this.instance.get(`/common/currencyData`)
    }
    // 单位转换列表
    unitList(){
        return this.instance.get(`/common/unitData`)
    }
}


const api = new Api();
export default api;
